import styled from 'styled-components'
import { COLORS } from '@assets/styles/colors'

export const SearchContainer = styled.div`
	padding: 13px 17px 13px 16px;
	background: #fff;
	border-radius: 22px;
	border: 1px solid ${COLORS.LIGHT_GREY};

	img {
		width: 21px;
		height: 21px;
		flex-shrink: 0;
		opacity: 0.72;
	}
`

export const InputField = styled.input`
	outline: none;
	background: none;
	border: none;
	font-size: 16px;
	line-height: 22px;
	color: #111827;
	width: 100%;

	&::placeholder {
		color: #8a8f99;
	}
`
